export default {
  'createBill.purchaseorderno': 'Purchase Order No :',
  // "createBill.phone": "Phone",
  'createBill.IranBranchOffice,No.18,AlvandBuilding,AlvandSt.ArgentinaSq.,Tehran,Iran.Phone:+98 21 88663088': `
Iran Branch Office, No.18, Alvand Building, Alvand St.
Argentina Sq., Tehran, Iran.
Phone: +98 21 88663088`,
  // "createBill.argentina": "Argentina Sq., Tehran, Iran.",
  'createBill.date': 'Date',
  'createBill.supplieraddress': 'Supplier Address:',
  'createBill.3061valiasrsttehraniran': '#3061, Valiasr St,, Tehran, Iran',
  'createBill.requestername': 'Requester Name',
  'createBill.paymentterms': 'Payment Terms',
  'createBill.frominvoicereceipt': 'from invoice receipt',
  'createBill.projectname': 'Project Name :',
  'createBill.test': 'Test',
  'createBill.pos': 'POS',
  'createBill.description': 'Description',
  'createBill.quantity': 'Quantity',
  'createBill.uom': 'UOM',
  'createBill.netprice': 'NetPrice',
  'createBill.per': 'Per',
  'createBill.totalprice': 'Total Price',
  'createBill.curr': 'Curr',
  'createBill.deliverydate': 'Delivery Date',
  'createBill.NECfullHD1024': 'NEC - Full HD 1024',
  'createBill.sonyultraHD': 'SONY - Ultra HD',
  'createBill.xiaominormalheadset': 'Xiaomi - Normal Headset',
  'createBill.beatshighqualitywireless': 'Beats - High Quality - Wireless',
  'createBill.totalgrossamount': 'TOTAL GROSS AMOUNT (including tax if any)',
  'createBill.months': 'Month',
  'createBill.hours': 'Hour',
  'createBill.days': 'Day',
  'createBill.novartispharmaserviceAG': 'Novartis Pharma Service AG',
};
